module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a1"
  }, [_c('PinchInImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [(_vm.isEnvironmentPc()) ? _c('div', {
    staticClass: "toparea-play"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelectAnswer),
      expression: "showSelectAnswer"
    }],
    staticClass: "flexcenter"
  }, [_c('div', {
    staticClass: "input w300"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showText),
      expression: "showText"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.eText))
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "icon-voice item",
    on: {
      "click": function($event) {
        return _vm.audioPlay(_vm.currentData.sounds[0])
      }
    }
  })])]) : _c('div', {
    staticClass: "toparea-play",
    style: ({
      visibility: _vm.isAutoAdjustShown ? 'visible' : 'hidden'
    })
  }, [_c('div', {
    staticClass: "flexcenter",
    style: ({
      visibility: _vm.showSelectAnswer ? 'visible' : 'hidden'
    })
  }, [_c('div', {
    staticClass: "input w300"
  }, [_c('span', {
    style: ({
      visibility: _vm.showText ? 'visible' : 'hidden'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.eText)
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "icon-voice item",
    on: {
      "click": function($event) {
        return _vm.audioPlay(_vm.currentData.sounds[0])
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "auto-adjust",
      rawName: "v-auto-adjust"
    }],
    staticClass: "cards-container active-type1"
  }, [_vm._l((_vm.templateTypes), function(templateType, index) {
    return _c('div', {
      key: index,
      staticClass: "card-inner card-voice",
      class: templateType
    }, _vm._l((_vm.actGroupIndexList[index]), function(item) {
      return _c('div', {
        key: item,
        staticClass: "item",
        class: {
          challenge: _vm.isChallenge(_vm.pathstep.acts[item])
        }
      }, [_c('A1act', {
        attrs: {
          "act": _vm.pathstep.acts[item],
          "answer": _vm.currentData,
          "questionState": _vm.questionStatus,
          "challengeFillPolicy": _vm.pathstep.challengeFillPolicy,
          "runmode": _vm.pathstep.mode,
          "index": item,
          "isSelect": _vm.isSelect
        },
        on: {
          "audioPause": function($event) {
            return _vm.audioPause()
          },
          "isCorrect": function($event) {
            return _vm.childIsCorrect(item)
          },
          "isInCorrect": function($event) {
            return _vm.childIsInCorrect()
          },
          "clickImage": function($event) {
            return _vm.clickItem(_vm.pathstep.acts[item], item)
          },
          "onTouchStart": _vm.onTouchStart,
          "onTouchEnd": _vm.onTouchEnd
        }
      })], 1)
    }), 0)
  }), _vm._v(" "), (_vm.isScrollIconVisible) ? _c('div', {
    staticClass: "icon-scroll"
  }) : _vm._e()], 2)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33c36159", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-33c36159","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A1.vue
// module id = 614
// module chunks = 1